import { createContext } from 'react';

import { TNotificationStore } from '@/domain/notification/NotificationStore';

const NotificationStoreContext = createContext<TNotificationStore>(null);

export default NotificationStoreContext;
